import { useCurrentBilikZones } from 'context/current-bilik-zones-context';
import Reviews from 'modules/review/components/Reviews';
import React, { FunctionComponent, useMemo } from 'react';

const ReviewsPage: FunctionComponent = () => {
  const { currentBilikZones } = useCurrentBilikZones();

  const title: React.ReactElement = useMemo(
    () => (
      <>
        Avis
        <small>
          {currentBilikZones
            ? currentBilikZones.map((zone) => zone.mainCityCode).join(', ')
            : 'Toutes les zones'}
        </small>
      </>
    ),
    [currentBilikZones],
  );

  return <Reviews title={title} />;
};

export default ReviewsPage;
